import { Component } from '@angular/core';
import { AboutUsComponent } from '../about-us/about-us.component';
import { ServicesComponent } from '../services/services.component';
// import { ContactUsComponent } from '../contact-us/contact-us.component';
import { SponsorsComponent } from '../sponsors/sponsors.component';
import { MissionandvisionComponent } from '../missionandvision/missionandvision.component';
import { ScrollService } from '../../services/scroll.services';

@Component({
  selector: 'app-home',
  imports: [AboutUsComponent,ServicesComponent,SponsorsComponent,MissionandvisionComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  constructor(private scrollService: ScrollService) {}

  ngOnInit(): void {
    this.scrollService.scrollTo$.subscribe((sectionId) => {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
}
